export function isCheckedFolder(checkedFolderId: number, currentFolderId: number) {
	return checkedFolderId === currentFolderId;
}

export function isURLNotEntered(length: number) {
	return length <= 0;
}

export function isFolderChecked(checkedFolderState: number) {
	return checkedFolderState !== -1;
}

export function isMemoEntered(length: number) {
	return length <= 0;
}
